import React from "react";
import { AiFillInstagram, AiFillLinkedin, AiFillGithub } from "react-icons/ai";

const Footer = () => {
  return (
    <div className=" dark:bg-[#e6af2e] dark:text-[#191716] h-24 md:flex  items-center bg-[#320a28] text-white justify-evenly">
      <div className="text-xl mb-3 md:mb-0 pt-2 md:pt-0 ml-5 md:ml-0  ">
        Copyright@2023 <span className="font-bold">Bounedjar Faical</span>{" "}
      </div>
      <div className="flex text-4xl gap-8 justify-center">
        <a
          className="items-cecnter hover:text-purple-500"
          href="https://www.instagram.com/faical.visuals"
        >
          <AiFillInstagram />
        </a>
        <a
          className="items-cecnter hover:text-blue-700"
          href="https://www.linkedin.com/in/bounedjarfaical"
        >
          <AiFillLinkedin />
        </a>
        <a
          className="items-cecnter hover:text-gray-300 dark:hover:text-gray-600"
          href="https://github.com/faicalbounedjar"
        >
          <AiFillGithub />
        </a>
      </div>
    </div>
  );
};

export default Footer;
